import {
  Component,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
} from '@angular/core';
import { Job } from '../../class/job.class';
import { TranscriptionSegment } from '../../models/translated-segment.model';
import { TimebarComponent } from '../timebar/timebar.component';
import { AudioLineComponent } from '../audio-line/audio-line.component';
import { TranscriptionSegmentsLineComponent } from '../transcription-segment-line/transcription-segment-line.component';

@Component({
  selector: 'app-transcription-visualizer',
  imports: [
    TimebarComponent,
    AudioLineComponent,
    TranscriptionSegmentsLineComponent,
  ],
  templateUrl: './transcription-visualizer.component.html',
  styleUrl: './transcription-visualizer.component.scss',
})
export class TranscriptionVisualizerComponent {
  job: InputSignal<Job> = input.required<Job>();
  audio: InputSignal<Blob> = input.required<Blob>();
  transcriptionSegments: InputSignal<TranscriptionSegment[]> =
    input.required<TranscriptionSegment[]>();
  onActiveSegementChange: OutputEmitterRef<TranscriptionSegment | undefined> =
    output();
}
